import { clipMargins, drawWithStyle } from "../../helpers/Draw";
import { ICanvasRenderOptions } from "../abstraction/IDraw2D";
import { IDrawStyle } from "../abstraction/IDrawStyle";
import { ITimeTrack, ITimeValue } from "../abstraction/ITimeTrack";
import { IViewLayer } from "../abstraction/IViewLayer";


interface IPitchValue {
    pitch: number;
    power: number;
}


export class PitchTrack implements ITimeTrack<IPitchValue> {

    protected _data: ITimeValue<IPitchValue>[];
    protected _layer: IViewLayer;
    protected _visible: boolean = true;

    constructor() {
        this._data = [];
        this.style = {
            strokeWidth: 2,
            strokeColor: "#0D47A1"
        }
    }

    attach(layer: IViewLayer) {
        this._layer = layer;
    }


    draw2D(ctx: CanvasRenderingContext2D, options: ICanvasRenderOptions) {

        if (this._data.length == 0)
            return;

        ctx.save();

        clipMargins(ctx, this._layer.host.margin, options.viewSize);

        this._data.forEach((item, index) => {

            if (index == 0)
                return;

            if (!this.data[index - 1].value && this.data[index].value)
                ctx.moveTo(item.time, Math.log2(item.value.pitch));
            else if (this.data[index].value)
                ctx.lineTo(item.time, Math.log2(item.value.pitch));
        });

        ctx.resetTransform();

        drawWithStyle(ctx, this.style);

        ctx.restore();
    }

    clear() {
        this._data = [];
    }


    add(time: number, value: IPitchValue) {

        for (var i = this._data.length - 1; i >= 0; i--) {

            if (this._data[i].time > time)
                this._data.splice(i, 1);
        }

        this._data.push({ time, value });

        this._layer?.requestRender();
    }

    get data() {
        return this._data;
    }

    get visible() {
        return this._visible;
    }

    set visible(value: boolean) {
        this._visible = value;
        this._layer?.requestRender();
    }

    style: IDrawStyle;

    readonly name = "pitch";
}